var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_679_1608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900 0H0V600H900V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.001 486.7C836.701 479.9 773.401 473.1 713.701 449.7C654.001 426.3 598.001 386.3 564.101 335.9C530.301 285.4 518.601 224.6 497.201 166.8C475.701 109.1 444.501 54.6 413.301 0H900.001V486.7Z",
    fill: "#FFECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 365.1C852.5 359.9 805.1 354.8 760.3 337.3C715.5 319.7 673.5 289.7 648.1 251.9C622.7 214.1 614 168.4 597.9 125.1C581.8 81.8 558.4 40.9 534.9 0H900V365.1Z",
    fill: "#FFC88E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.002 243.4C868.402 240 836.702 236.6 806.902 224.8C777.002 213.1 749.002 193.2 732.102 167.9C715.102 142.7 709.302 112.3 698.602 83.4C687.902 54.6 672.202 27.3 656.602 0H900.002V243.4Z",
    fill: "#FFA341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.001 121.7C884.201 120 868.401 118.3 853.401 112.4C838.501 106.6 824.501 96.6 816.001 84C807.601 71.4 804.701 56.1 799.301 41.7C793.901 27.3 786.101 13.6 778.301 0H900.001V121.7Z",
    fill: "#FF9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 113.301C47.5 158.001 95 202.701 157.7 219.401C220.3 236.101 298.1 224.801 344.2 255.801C390.3 286.901 404.7 360.301 423.1 424.701C441.6 489.201 464.2 544.601 486.7 600.001H0V113.301Z",
    fill: "#FFECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 234.902C35.6 268.502 71.3 302.002 118.2 314.502C165.2 327.002 223.6 318.602 258.1 341.902C292.7 365.202 303.5 420.202 317.4 468.502C331.2 516.902 348.1 558.402 365.1 600.002H0V234.902Z",
    fill: "#FFC88E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 356.602C23.8 379.002 47.5 401.302 78.8 409.702C110.2 418.002 149 412.402 172.1 427.902C195.1 443.402 202.3 480.202 211.6 512.402C220.8 544.602 232.1 572.302 243.4 600.002H0V356.602Z",
    fill: "#FFA341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 478.301C11.9 489.501 23.8 500.701 39.4 504.801C55.1 509.001 74.5 506.201 86 514.001C97.6 521.701 101.2 540.101 105.8 556.201C110.4 572.301 116 586.101 121.7 600.001H0V478.301Z",
    fill: "#FF9100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_1608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobOrange);
export default __webpack_public_path__ + "static/media/blob_orange.6bcc032ed19e6393cffc927b4b7f5746.svg";
export { ForwardRef as ReactComponent };